/**
 * Página pública genérica para los tipos legales sin ruta dedicada
 * (terminos/privacidad/cookies tienen su propia ruta por SEO/histórico).
 * Cubre los 10 tipos canónicos de sm_legal_documents sin duplicar componentes.
 */
import { createFileRoute, notFound } from "@tanstack/react-router";
import { LegalPublicPage } from "@/components/legal/LegalPublicPage";
import type { LegalDocumentType } from "@/lib/db-service/legal";
import { ALL_LEGAL_DOCUMENT_TYPES, LEGAL_DOCUMENT_TITLES as TITLES } from "@/lib/legal-public-links";
import { publicSitePath } from "@/lib/public-site";

export const Route = createFileRoute("/legal/$type")({
  component: LegalTypePage,
  loader: ({ params }) => {
    if (!ALL_LEGAL_DOCUMENT_TYPES.includes(params.type as LegalDocumentType)) {
      throw notFound();
    }
  },
  head: ({ params }) => {
    const title = TITLES[params.type as LegalDocumentType] ?? "Documento legal";
    return {
      meta: [{ title: `${title} — Structura` }],
      links: [{ rel: "canonical", href: publicSitePath(`/legal/${params.type}`) }],
    };
  },
});

function LegalTypePage() {
  const { type } = Route.useParams();
  const title = TITLES[type as LegalDocumentType] ?? "Documento legal";
  return <LegalPublicPage title={title} type={type} />;
}
